'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* HELD — not cleared for publication, and not routed.
 * Trustoo has given no approval and no testimonial; `_held/` is a Next.js
 * private folder, so nothing here renders until the directory is moved up
 * one level. Same mechanism as the stories legal took down in #200.
 *
 * CONFIRM BEFORE THE HOLD LIFTS: the only operational signal on file is Linear's Sep 2026 HubSpot conversation-reply issue, which establishes the helpdesk and that the agent replies into it. Verify which channels are live, what the agent handles end to end, and what escalates.
 *
 * No stats row and no results table: no figure exists for Trustoo anywhere,
 * and a placeholder would be an invented claim. Add the stats, the table and
 * the six-place number check from the customer-stories skill in the same
 * commit that lands cleared figures. */
const TrustooCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Trustoo"
        title={t.customerStories['trustoo_hero_title']}
        subtitle={t.customerStories['trustoo_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'Trustoo',
          customerName: 'Trustoo',
          company: t.customerStories['trustoo_company_description'],
          industry: t.customerStories['trustoo_industry'],
          websiteUrl: 'https://www.trustoo.nl',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['trustoo_location'],
            },
          ],
          keyResults: [
            t.customerStories['trustoo_key_result_1'],
            t.customerStories['trustoo_key_result_2'],
            t.customerStories['trustoo_key_result_3'],
            t.customerStories['trustoo_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['trustoo_intro']}</p>

        <h2>{t.customerStories['trustoo_challenge_title']}</h2>
        <p>{t.customerStories['trustoo_challenge_p1']}</p>
        <p>{t.customerStories['trustoo_challenge_p2']}</p>
        <p>{t.customerStories['trustoo_challenge_p3']}</p>

        <h2>{t.customerStories['trustoo_solution_title']}</h2>
        <p>{t.customerStories['trustoo_solution_p1']}</p>
        <p>{t.customerStories['trustoo_solution_p2']}</p>
        <p>{t.customerStories['trustoo_solution_p3']}</p>

        <h2>{t.customerStories['trustoo_impact_title']}</h2>
        <p>{t.customerStories['trustoo_impact_p1']}</p>
        <p>{t.customerStories['trustoo_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default TrustooCaseStudy;
